// extracted by mini-css-extract-plugin
export default {"code-panel":"CodePanel_code-panel__LPQWT","format-option":"CodePanel_format-option__igPsU","data":"CodePanel_data__w2oey"};